






































import { RootState } from '@/store/store';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import {
  CourseTypeOption,
  CreateModuleDTO,
  ModuleResponseDTO
} from '@/jbi-shared/dto/jtms.dtos';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { ToastProgrammatic } from 'buefy';
import ModuleForm from './components/ModuleForm.vue';

@Component({
  components: {
    ModuleForm
  }
})
export default class CreateModuleModal extends Vue {
  @Prop({ type: Object }) module!: ModuleResponseDTO;

  name: string = '';
  selectedCourseType: CourseTypeOption | null = null;
  createModuleFormHasError: boolean = false;

  @Action('course/getCourseTypes')
  getCourseTypes!: () => Promise<CourseTypeOption[]>;

  @State((state: RootState) => state.course.courseTypes)
  courseTypes!: CourseTypeOption[];

  @Action('module/createModule')
  createModule!: (options: CreateModuleDTO) => void;

  @State((state: RootState) => state.module.apiState.createModule)
  createModuleApiState!: ApiState;

  created() {
    this.getCourseTypes();
  }

  processCreateModule() {
    if (this.name) {
      const payload: CreateModuleDTO = {
        name: this.name,
        courseTypeId: this.selectedCourseType
          ? this.selectedCourseType.id
          : undefined
      };

      this.createModule(payload);
    }
  }

  updateErrorState(hasFieldError: boolean) {
    this.createModuleFormHasError = hasFieldError;
  }

  closeModal() {
    this.$emit('close');
  }

  triggerPageRefresh() {
    this.$emit('refreshPage');
  }

  @Watch('createModuleApiState', { deep: true })
  onCreateModuleApiStateChanged(state: ApiState) {
    if (state.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: `Course Module successfully created.`
      });

      this.closeModal();
      this.triggerPageRefresh();
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 5000
      });
    }
  }
}
